<template>
<div id="tabbed-menu">
    <ul class="tab-list" ref="tab-list" >
        <!-- active -->
        <li class="tab" >
            <a href="#" class="tab-anchor" >
                <img class="tab-icon" src="https://cdns.iconmonstr.com/wp-content/assets/preview/2012/240/iconmonstr-equalizer-4.png">
                <span class="tab-text" >Civic Participation</span>
            </a>
        </li>
        <li class="tab" >
            <a href="#" class="tab-anchor" >
                <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/equalizer-white.png">
                <span class="tab-text" >Our Changing Landscape</span>
            </a>
        </li>
        <li class="tab" >
            <a href="#" class="tab-anchor" >
                <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/equalizer-white.png">
                <span class="tab-text" >We the People</span>
            </a>
        </li>
        <li class="tab" >
            <a href="#" class="tab-anchor" >
                <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/equalizer-white.png">
                <span class="tab-text" >A New Government &amp; Constitution</span>
            </a>
        </li>
        <li class="tab" >
            <a href="#" class="tab-anchor" >
                <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/equalizer-white.png">
                <span class="tab-text" >A Series of Refoundings?</span>
            </a>
        </li>
        <li class="tab" >
            <a href="#" class="tab-anchor" >
                <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/equalizer-white.png">
                <span class="tab-text" >A People in the World</span>
            </a>
        </li>
        <li class="tab" >
            <a href="#" class="tab-anchor" >
                <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/equalizer-white.png">
                <span class="tab-text" >A People with Contemporary Debates</span>
            </a>
        </li>
    </ul>
</div>
</template>

<script>
export default {
    name: 'pa-tabbed-menu',
    mounted(){

        this.$nextTick(() => {
            setTimeout(() => {
                var num_tabs = this.$refs['tab-list'].children.length;
                this.tabs = this.$refs['tab-list'].children.length;
                this.tabs.forEach(tab => {
                    tab.$el.dataset['num-tabs'] = num_tabs;
                });
            }, 50);
        });
    },
}
</script>

<style lang="scss">
#tabbed-menu{
    padding: 0px;
    margin: 0px;

    .tab-list{
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding-inline-start: 0px;
        padding-inline-end: 0px;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        flex-direction: column;
        margin-bottom: 20px;
        background-color: #000;
        border-top: 1px #505050 solid;
        border-bottom: 1px #505050 solid;

        @media screen and (min-width: 768px){

            &{
                flex-direction: row;
                align-items: initial;
                margin-bottom: 0px;
            }
        }

        .tab{
            list-style: none;
            padding: 0px;
            margin: 0px;
            width: calc( (100vw - 40px) / attr(data-num-tabs) );
            max-width: 125px;

            .tab-anchor{
                display: inline-block;
                color: #fff;
                padding: 10px 20px 20px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .tab-icon{
                    width: 30px;
                    padding: 10px 0px 20px;
                }

                .tab-text{
                    text-align: center;
                    font-size: .9em;
                }
            }

            &.active,
            &:hover{
                background-color: #fff;

                .tab-anchor{
                    color: #333;
                }
            }
        }
    }
}
</style>